import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GlossaryState } from 'common/modules/app/glossaries';
import { Glossary } from 'common/utils/glossary';
import { BoardStatus, setStatus } from 'common/modules/app/board';
import { UserInformation } from 'common/modules/domain/user';
import { Master } from 'common/modules/app/master';
import { Button, Column } from 'common/components';

import { AppState } from 'pages';

interface OwnProps {
  /** アイコンボタンやリストのカラムなどの種類 */
  type: 'button' | 'column';
  /** テスト用識別子 */
  'data-test': string;
}

// StoreのStateからComponentに渡すPropsへ
const useStateProps = () => {
  const userState = useSelector<AppState, UserInformation>(
    (state) => state.domain.user
  );
  const masterState = useSelector<AppState, Master>(
    (state) => state.app.master
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );

  const language: string | undefined =
    masterState.language[userState.language]?.glossary;

  return {
    language: language,
    glossary: Glossary.instance(glState)
  };
};

// Actionをdispatchする関数からComponentに渡すPropsへ
const useDispatchProps = () => {
  const dispatch = useDispatch();

  /** クリック処理 */
  const onClickLanguage = () => {
    dispatch(setStatus(BoardStatus.LANGUAGE_DISP));
  };

  return {
    onClick: onClickLanguage
  };
};

/**
 * 言語のボタンのContainer Component
 */
export default function ContainerComponent(
  ownProps: OwnProps & React.ComponentProps<'div'>
) {
  const _props = {
    ...useDispatchProps(),
    ...useStateProps()
  };
  const _button = (
    <Button type="languageButton" data-test={ownProps['data-test']} {..._props}>
      {_props.glossary.glx(_props.language)}
    </Button>
  );
  const _column = (
    <Column
      type="item"
      subType="language full"
      data-test={ownProps['data-test']}
      {..._props}
    >
      {_props.glossary.glx(_props.language)}
    </Column>
  );
  return ownProps.type === 'button' ? _button : _column;
}
